// extracted by mini-css-extract-plugin
export default {"AnimationContainer":"SendConfirmation_AnimationContainer__jIPwC"};